module.exports = __webpack_public_path__ + "static/media/logo-mapbiomas-degradation.7b570bfb.svg";